import axios from 'axios'
import {backendUrl, hcpUrl, disdukUrl, esignDocumentConverterURL} from './config/env'


export const apiServer = axios.create({
  baseURL: backendUrl
})

export const hcpServer = axios.create({
  baseURL: hcpUrl
})

export const apiDisduk = axios.create({
  baseURL: disdukUrl
})

export const docConverter = axios.create({
  baseURL: esignDocumentConverterURL
})

apiServer.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
apiDisduk.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
hcpServer.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
docConverter.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

hcpServer.defaults.headers.common.Authorization = `HCP cmVuYmFuZw==:161ebd7d45089b3446ee4e0d86dbcf92`

export const axiosGlobalConfig = axios

export const fileUrl = backendUrl
